import React, { FC } from 'react';

import { useModalControl } from 'Src/feature/modal/useModalControl';
import { PaymentMethodModal } from 'Src/feature/payment/PaymentMethodModal';

const sectionId = 'CheckPaymentMethodModal';

interface CheckPaymentMethodModalProps {
  control: ReturnType<typeof useModalControl<{ Close: 'on-user-cancel' | 'on-option-selected' }>> & {
    title: string;
    options: { value: number, label: string }[];
    onOptionClick: (opt: { value: number, label: string }) => void;
  }
}

const CheckPaymentMethodModal: FC<CheckPaymentMethodModalProps> = ({ control, ...rest }) => (
  <PaymentMethodModal
    data-testid={sectionId}
    {...rest}
    open={control.isOpen}
    title={control.title}
    onClose={() => control.close('on-user-cancel')}
    paymentMethodOptions={control.options}
    onOptionClick={control.onOptionClick}
  />
);

export { CheckPaymentMethodModal };
export type { CheckPaymentMethodModalProps };
